import { Component, Inject, Input } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
   selector: 'meeting-scheduler-modal',
   templateUrl: './meeting-scheduler-modal.component.html',
   styleUrls: ['./meeting-scheduler-modal.component.scss'],
   standalone: false,
})
export class MeetingSchedulerModalComponent {
   constructor(
      private dialogRef: MatDialogRef<MeetingSchedulerModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { rmName: string; subject: string }
   ) {}

   close() {
      this.dialogRef.close()
   }
}
